import styled from '@emotion/styled';
import { Switch } from '@mui/material';
import { theme } from 'theme';

export const SwitchWrapper = styled.div`
  margin: 1px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSwitch = styled(Switch)`
  overflow: visible;
  &.MuiSwitch-sizeSmall {
    width: 30px;
    height: 16px;
    padding: 0;
    border-radius: 50px;
    & .MuiSwitch-switchBase {
      padding: 3px 3px;
      &.Mui-checked {
        transform: translateX(14px);
      }
    }
    & .MuiSwitch-thumb {
      width: 10px;
      height: 10px;
    }
    & .MuiSwitch-track {
      border-radius: 50px;
    }
  }
  &.MuiSwitch-sizeMedium {
    width: 40px;
    height: 20px;
    padding: 0;
    border-radius: 50px;
    & .MuiSwitch-switchBase {
      padding: 3px 4px;
      &.Mui-checked {
        transform: translateX(19px);
      }
    }
    & .MuiSwitch-thumb {
      width: 14px;
      height: 14px;
    }
    & .MuiSwitch-track {
      border-radius: 50px;
    }
  }

  & .MuiSwitch-switchBase {
    &.MuiSwitch-colorPrimary {
      & + .MuiSwitch-track {
        background: ${theme.palette.grey.A100} !important;
        opacity: 1 !important;
      }
    }
    &.MuiSwitch-colorDefault {
      &.Mui-checked {
        & + .MuiSwitch-track {
          background: #626262;
        }
        & .MuiSwitch-thumb {
          background: ${theme.palette.common.white};
          border-color: ${theme.palette.common.white};
        }
      }

      & .MuiSwitch-thumb {
        background: ${theme.palette.common.white};
        border: none;
        box-shadow: none;
      }
      & + .MuiSwitch-track {
        background: ${theme.palette.grey[300]};
        border: none;
        opacity: 1;
      }
      &.Mui-disabled {
        opacity: 0.4;
        & + .MuiSwitch-track {
          opacity: 0.4;
        }
      }
    }
  }
`;
